import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES, SERVICE_CATEGORIES } from "../data/content";
import { FadeUp, Overline } from "../components/Reveal";
import { CTASection, PageHero } from "../components/PageHero";
import { IMG } from "../data/content";

const CategoryBlock = ({ cat, index }) => (
  <section className={`hospitality-background py-12 sm:py-16 lg:py-20 relative overflow-hidden ${index % 2 === 1 ? "bg-cream-subtle" : ""}`} data-testid={`services-category-${cat.id}`}>
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
      <FadeUp className="max-w-2xl">
        <Overline>{cat.title}</Overline>
        <h2 className="mt-4 font-display font-extrabold tracking-tight leading-[1.12] text-3xl sm:text-4xl text-aubergine">
          {cat.tagline}
        </h2>
        <p className="mt-4 text-ink-muted leading-relaxed">{cat.desc}</p>
      </FadeUp>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 sm:mt-10">
        {SERVICES.filter((s) => s.category === cat.id).map((s, i) => (
          <FadeUp key={s.id} delay={i * 0.07}>
            <Link
              to={s.slug}
              data-testid={`service-card-${s.id}`}
              className="hospitality-card group flex flex-col h-full rounded-[1.75rem] overflow-hidden border border-line bg-white shadow-sm hover:-translate-y-1.5 hover:shadow-[0_28px_70px_rgba(45,18,77,0.14)] transition-all duration-300"
            >
              <div className="relative aspect-[4/3] shrink-0 overflow-hidden">
                <img src={s.heroImg} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              </div>
              <div className="px-6 py-5 flex flex-1 items-center justify-between gap-3" style={{ background: s.color }}>
                <h3 className="font-display font-extrabold text-lg text-cream leading-snug">{s.title}</h3>
                <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center shrink-0 group-hover:bg-white/25 transition-colors duration-300">
                  <ArrowRight className="w-4 h-4 text-cream transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default function Services() {
  return (
    <main data-testid="services-page">
      <PageHero
        overline="Hospitality Services & Business Solutions"
        lines={["360° hospitality growth", "& business solutions"]}
        desc="Digital marketing, creative, technology and practical hospitality services for restaurants, cafés, hotels, resorts, pubs, cloud kitchens and event businesses."
        img="/photo-marketing.jpg"
        imgAlt="Planning digital marketing for business growth"
        accent="#D97706"
      />
      {SERVICE_CATEGORIES.map((cat, i) => (
        <CategoryBlock key={cat.id} cat={cat} index={i} />
      ))}
      <CTASection
        title="One business. One partner. Complete hospitality solutions."
        sub="You don't need to coordinate with multiple agencies and vendors for every requirement. GrowMyRestro brings your hospitality solutions together."
      />
    </main>
  );
}
